import { Input, InputProps, Text } from 'components/ui';
import { ChangeEvent, FC, forwardRef } from 'react';
import styled from 'styled-components';

const CharactersRemainingText = styled(Text)`
  margin-top: 10px;
`;

export interface CharactersRemainingInputProps extends InputProps {
  maxLength: number;
  value?: string;
}

/**
 * Needs to be a controlled input to work. control state in parent and pass down its value
 */
export const CharactersRemainingInput: FC<CharactersRemainingInputProps> =
  forwardRef(({ maxLength, onChange, ...props }, ref) => {
    const onValueChange = (
      e: ChangeEvent<HTMLInputElement | HTMLTextAreaElement>
    ) => {
      onChange?.(e);
    };

    return (
      <>
        <Input
          maxLength={maxLength}
          onChange={onValueChange}
          ref={ref}
          {...props}
        />
        <CharactersRemainingText
          textAlign='right'
          color='darkGrey'
          fontSize={0}
        >
          {!props.value && maxLength}
          {props.value && maxLength - props.value.length} Characters Remaining
        </CharactersRemainingText>
      </>
    );
  });
